const { uidispatcherInternal } = await import("uidispatcher_api/UidispatcherApiModule");
export const showIFrame = uidispatcherInternal.TagPrisonUtilModule.showIFrame;
export const getIFrameDomain = uidispatcherInternal.TagPrisonUtilModule.getIFrameDomain;
